export const normalizeOrderId = (id: string): string => {
  return id.length >= 14 ? id.replace(/(.{6})$/, '-$1') : id;
};
